import { useState } from 'react';
// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import DIOText from '../../../components/DIOText';
import SvgIconStyle from '../../../components/SvgIconStyle';


export default function PositionConsultationDialog({ open, goRegisterCompany, closeDialog }) {
  const [isSubmit, setIsSubmit] = useState(false);

  const goNext = async () => {
    try {
      setIsSubmit(true);
      await goRegisterCompany();
      setIsSubmit(false);
    } catch(err) {
      console.error(err);
      setIsSubmit(false);
    }
  }

  return (
    <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="dg">
      {/* contents */}
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <SvgIconStyle src={`/icons/ic_headphone.svg`} sx={{ width: 28, height: 28, color: 'error.main' }} />
        <Typography variant="h5" sx={{ wordBreak: "keep-all" }} paragraph>
          선택하기 어렵다면 <DIOText />에서 상담해드릴게요.
        </Typography>
        <Typography>
          어떤 포지션을 선택해야할지 모르겠거나, 찾고 있는 포지션이 여기 없다면 이 단계를 건너뛰고 회사 정보를 먼저 입력해주세요.
          <br/><br/>
          <DIOText />에서 영업일 기준 2일 이내로 연락드리겠습니다.
        </Typography>
      </DialogContent>
      {/* buttons */}
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack
          display="flex"
          justifyContent="flex-end"
          direction={{ xs: "column-reverse", sm: "row" }}
          sx={{ width: 1 }}
          spacing={2}
        >
          <LoadingButton
            onClick={closeDialog}
            size="large"
            sx={{ px: 5 }}
            loading={isSubmit}
          >
            닫기
          </LoadingButton>
          <LoadingButton
            variant="contained"
            onClick={goNext}
            size="large"
            sx={{ px: 5 }}
            loading={isSubmit}
          >
            회사 정보 입력하기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
